module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority/sorority-3-large-91215e15d1e6cc87dd03b087a54f99bf.jpg";